var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("wv-steak-house-default-section", {
    staticClass: "menu--section-wine_list",
    attrs: {
      section: _vm.section,
      menu: _vm.menu,
      "menu-item-component": "wv-steak-house-wine-list-item",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }